var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.861 3.194a4.887 4.887 0 0 0 6.08 4.739v9.984H2.5V2.982h7.366q-.005.104-.005.212M6.233 14.183h5.975V12.69H6.233zm0-2.986h5.975V9.702H6.233zm0-2.988h2.24V6.716h-2.24zm8.184-7.159a.344.344 0 0 1 .639 0l.172.415c.293.707.84 1.272 1.527 1.578l.487.217a.36.36 0 0 1 0 .653l-.515.229a2.96 2.96 0 0 0-1.506 1.527l-.167.384a.344.344 0 0 1-.634 0l-.167-.384a2.96 2.96 0 0 0-1.506-1.527l-.516-.229a.36.36 0 0 1 0-.653l.488-.217a2.96 2.96 0 0 0 1.526-1.578z"
  })));
};
export default SvgNews;